// StepComponentMap.ts
import { ITransportDetailSection } from 'types/transport';
import Booking from './Booking';
import ExportCustoms from './ExportCustoms';
import DocumentCutoff from './DocumentCutoff';
import CargoIn from './CargoIn';
import CargoOut from './CargoOut';
import Departed from './Departed';
import InTransit from './InTransit';
import Arrived from './Arrived';


export const stepComponent: Record<string, React.ComponentType<ITransportDetailSection>> = {
    booking: Booking,
    exportcustoms: ExportCustoms,
    documentcutoff: DocumentCutoff,
    cargoin: CargoIn,
    cargoout: CargoOut,
    departed: Departed,
    intransit: InTransit,
    arrived: Arrived,
};